import { AfterViewInit, ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormField, FormFieldOption } from "../../../../../dto/util/form-field";
import { TranslateService } from "@ngx-translate/core";
import { combineLatest, firstValueFrom } from "rxjs";
import { FormGroup, Validators } from "@angular/forms";
import { Constants } from "../../../../../constants/constants";
import { ListasService } from "../../../../../services/listas.service";
import { PersonaLoginDTO } from "../../../../../dto/util/persona.dto";
import { LiquidacionJudicialService } from "../services/liquidacion-judicial.service";
import {
  DatosProfesionalesDTO,
  ItemTablaDTO,
  LiquidacionJudicialDTO, ProfesionalDTO, RespuestaDTO,
  RespuestaEliminarDTO, TablaProfesionalesDTO
} from "../models/liquidacion-judicial-DTO";
import { AlertaModalService } from "../../../../../services/util/alerta-modal.service";
import { Router } from "@angular/router";
import { InfoPantallaDTO } from "../../../../../dto/util/infoPantallaDTO";
import { Location } from "@angular/common";
import { UtilService } from "../../../../../services/util.service";
import { TramiteService } from "../../../../../services/tramite.service";
import { TramiteDTO } from "../../../models/tramiteDTO";
import { ListaValorDto } from "../../../../../dto/expediente/lista-valor.dto";
import { TipoAnexoTipoTramiteDto } from "../../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto";
import { ArchivoItemDto } from "../../../../util/archivos-tramite/dto/ArchivoItemDto";
import { PaisDto } from "../../../../../dto/expediente/pais.dto";
import { AnexoPrecargaResponseDto } from "../../../../../dto/anexo/anexo-tramite.dto";
import { TipoDocumentoDto } from "../../../../../dto/expediente/tipo-documento.dto";
import { ListaValorRequestDto, ListaValorResponseDto } from "../../../../../dto/tramites/lista_valor.dto";
import { TableColumn } from "../../../../../dto/util/table-column";
import { TableAction } from "../../../../../dto/util/table-action";
import { ConfigurarCuentasService } from '../../../../configuracion-cuenta/services/configurar-cuentas.service';
import { FormComponent } from '../../../../util/form/form.component';

declare function nextItemAdvanceLineIHorizonal(event: any): void;

@Component({
  selector: 'app-liq-judicial-pn-comerciante',
  templateUrl: './liq-judicial-pn-comerciante.component.html',
  styleUrl: './liq-judicial-pn-comerciante.component.scss'
})
export class LiqJudicialPnComercianteComponent implements OnInit {
  // Formularios
  camposIDdeudor: FormField[] = [];
  formIDdeudor!: FormGroup;
  camposInfoProfesionales: FormField[] = [];
  formInfoProfesionales!: FormGroup;
  formMemoriaExplicativa!: FormGroup;
  camposSupuestos: FormField[] = [];
  formSupuestos!: FormGroup;
  camposCumplimientoHipotesis: FormField[] = [];
  formCumplimiento!: FormGroup;
  camposInfoFinancieraMes: FormField[] = [];
  formInfoFinancieraMes!: FormGroup;
  camposInfoFinancieraAnio: FormField[] = [];
  formInfoFinancieraAnio!: FormGroup;
  camposEstadosFinancieros: FormField[] = [];
  formEstadosFinancieros!: FormGroup;
  camposInventario: FormField[] = [];
  formInventario!: FormGroup;
  camposOtrosDocumentos: FormField[] = [];
  formOtrosDocumentos!: FormGroup;
  camposDocumentosAdicionales: FormField[] = [];
  formDocumentosAdicionales!: FormGroup;
  campoTipoRevisor: FormField[] = [];
  formTipoRevisor!: FormGroup | undefined;
  camposRevisorPN: FormField[] = [];
  formRevisorPN!: FormGroup | undefined;
  camposRevisorPJ: FormField[] = [];
  formRevisorPJ!: FormGroup | undefined;
  campoTipoApoderado: FormField[] = [];
  formTipoApoderado!: FormGroup | undefined;
  camposApoderadoPN: FormField[] = [];
  formApoderadoPN!: FormGroup | undefined;
  camposApoderadoPJ: FormField[] = [];
  formApoderadoPJ!: FormGroup | undefined;
  campoTipoContador: FormField[] = [];
  formTipoContador!: FormGroup | undefined;
  camposContadorPN: FormField[] = [];
  formContadorPN!: FormGroup | undefined;
  camposContadorPJ: FormField[] = [];
  formContadorPJ!: FormGroup | undefined;
  // Tablas
  columnasRevisor: TableColumn[] = [];
  columnasApoderado: TableColumn[] = [];
  columnasContador: TableColumn[] = [];
  accionesRevisor: TableAction[] = [];
  accionesApoderado: TableAction[] = [];
  accionesContador: TableAction[] = [];
  datosRevisores: DatosProfesionalesDTO[] = [];
  datosApoderados: DatosProfesionalesDTO[] = [];
  datosContadores: DatosProfesionalesDTO[] = [];
  // Multilenguaje
  roiText: any = {};
  comunText: any = {};
  sociedadText: any = {};
  alertaText: any = {};
  // Listas
  macrosector: FormFieldOption[] = [];
  supuestos: FormFieldOption[] = [];
  baseContable: FormFieldOption[] = [];
  listaTipoSolicitante: ListaValorDto[] = [];
  listaNaturaleza: ListaValorDto[] = [];
  listaValorTipoSolicitante: ListaValorRequestDto[] = [];
  listaValorNaturaleza: ListaValorRequestDto[] = [];
  listaValorCodigoCIIU: ListaValorRequestDto[] = [];
  listaValorBaseContable: ListaValorRequestDto[] = [];
  listaValorCesePagos: ListaValorRequestDto[] = [];
  listaValorMacrosector: ListaValorRequestDto[] = [];
  paises: PaisDto[] = [];
  archivosPrecargados: AnexoPrecargaResponseDto[] = [];
  tiposDocumento: TipoDocumentoDto[] = [];
  revisores: FormFieldOption[] = [];
  apoderados: FormFieldOption[] = [];
  contadores: FormFieldOption[] = [];
  // Datos del usuario en sesión
  dataUsuario!: PersonaLoginDTO;
  // Number
  idTipoSolicitante!: number | undefined;
  idProceso!: number;
  idUsuario: number | undefined;
  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Listas de ids documentos requeridos por pasos
  idsFilesPasoUno: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoDos: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoTres: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoCuatro: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoCinco: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoSeis: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoSiete: TipoAnexoTipoTramiteDto[] = [];
  idsFilesPasoOcho: TipoAnexoTipoTramiteDto[] = [];
  // Archivos cargados por pasos
  archivosCargadosPasoUno: ArchivoItemDto[] = [];
  archivosCargadosPasoDos: ArchivoItemDto[] = [];
  archivosCargadosPasoTres: ArchivoItemDto[] = [];
  archivosCargadosPasoCuatro: ArchivoItemDto[] = [];
  archivosCargadosPasoCinco: ArchivoItemDto[] = [];
  archivosCargadosPasoSeis: ArchivoItemDto[] = [];
  archivosCargadosPasoSiete: ArchivoItemDto[] = [];
  archivosCargadosPasoOcho: ArchivoItemDto[] = [];
  // Boolean
  enviarArchivos = false;
  esPNC = false;

  mostrarTipoRevisor = false;
  mostrarTipoApoderado = false;
  mostrarTipoContador = false;
  mostrarRevisorPN = false;
  mostrarRevisorPJ = false;
  mostrarApoderadoPN = false;
  mostrarApoderadoPJ = false;
  mostrarContadorPN = false;
  mostrarContadorPJ = false;
  enviarEntidad = false;
  mostrarArchivoApoderado = false;
  // String
  nombreTramite = '';
  entidad = '';
  // Number
  currentYear = 0;
  lastYear = 0;
  yearBeforeLast = 0;
  twoYearsAgo = 0;

  @ViewChildren('FormComponent') personaComponentes!: QueryList<FormComponent>;

  constructor(
    private translate: TranslateService,
    private listaService: ListasService,
    private liqJudicialService: LiquidacionJudicialService,
    private alertaModalService: AlertaModalService,
    private router: Router,
    private utilService: UtilService,
    private tramiteService: TramiteService,
    private location: Location,
    private cdref: ChangeDetectorRef,
    private readonly _cuentaService: ConfigurarCuentasService
  ) {
    // Se obtienen los datos del usuario en la sesión
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    // Multilenguaje
    combineLatest([
      this.translate.stream('tramites'),
      this.translate.stream('comun-label'),
      this.translate.stream('liqJudicial-sociedad'),
      this.translate.stream('alertas')
    ]).subscribe(([tramitesText, comunLabelText, sociedadText, alertaText]) => {
      // Procesar el texto de 'tramites'
      for (const key of Object.keys(tramitesText)) {
        this.roiText[key] = tramitesText[key];
      }

      this.tramiteService.obtenerNombreEntidadPorId(1).subscribe({
        next: (data) => {
          this.entidad = data.entidad;
        },
        error: (err) => console.error('Error al obtener entidad', err),
      });

      // Procesar el texto de 'comun-label'
      for (const key of Object.keys(comunLabelText)) {
        this.comunText[key] = comunLabelText[key];
      }

      // Procesar el texto de 'liqJudicial-sociedad'
      for (const key of Object.keys(sociedadText)) {
        this.sociedadText[key] = sociedadText[key];
      }

      // Procesar el texto de 'alertas'
      for (const key of Object.keys(alertaText)) {
        this.alertaText[key] = alertaText[key];
      }
      this.listaTiposDocumento();
      // Se recargan los formularios que se encuentren en el ngOnInit
      this.initFormIDDeudor();
      // Revisor fiscal
      this.initFormTipoRevisor();
      this.initFormRevisorPN();
      this.initFormRevisorPJ();
      // Apoderado
      this.initFormTipoApoderado();
      this.initFormApoderadoPN();
      this.initFormApoderadoPJ();
      // Contador
      this.initFormTipoContador();
      this.initFormContadorPN();
      this.initFormContadorPJ();
      // Tablas
      this.initColumnsRevisor();
      this.initColumnsApoderado();
      this.initColumnsContador();
      this.initFormProfesionales();
      this.initFormMemoriaExplicativa();
      this.initFormSupuestos();
      this.initFormCumplimiento();
      this.initFormInfoFinancieraMes();
      this.initFormInfoFinancieraAnio();
      this.initFormEstadosFinancieros();
      this.initFormInventario();
      this.initFormOtrosDocumentos();
      this.initFormDocumentosAdicionales();
      // Cálculos para años parametrizables (Paso 8: estados financieros)
      this.currentYear = new Date().getFullYear();
      this.lastYear = this.currentYear - 1;
      this.yearBeforeLast = this.currentYear - 2;
      this.twoYearsAgo = this.currentYear - 3;
    });
  }
  ngOnInit(): void {
    this.listaService.listaValor(Constants.ROI_TIPO_SOLICITANTE).subscribe(resp => {
      this.idTipoSolicitante = resp.find(item => item.Codigo === 'PNC')?.Id;
    });
    // Se obtienen los datos del usuario en la sesión
    this.dataUsuario = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
    );
    this.nombreTramite = JSON.parse(
      sessionStorage.getItem(Constants.TRAMITE_SELECCIONADO)!
    );
    this.idUsuario = this.dataUsuario?.idUsuario;
    // Se inicializan formularios
    this.initFormIDDeudor();
    // Revisor fiscal
    this.initFormTipoRevisor();
    this.initFormRevisorPN();
    this.initFormRevisorPJ();
    // Apoderado
    this.initFormTipoApoderado();
    this.initFormApoderadoPN();
    this.initFormApoderadoPJ();
    // Contador
    this.initFormTipoContador();
    this.initFormContadorPN();
    this.initFormContadorPJ();
    this.initFormProfesionales();
    this.initFormMemoriaExplicativa();
    this.initFormSupuestos();
    this.initFormCumplimiento();
    this.initFormInfoFinancieraMes();
    this.initFormInfoFinancieraAnio();
    this.initFormEstadosFinancieros();
    this.initFormInventario();
    this.initFormOtrosDocumentos();
    this.initFormDocumentosAdicionales();
    // Se inicializan tablas
    this.initColumnsRevisor();
    this.initColumnsApoderado();
    this.initColumnsContador();
    // Listas
    this.listarMacrosector();
    this.listarSupuestos();
    this.listarBaseContable();
    this.listarTiposSolicitante();
    this.listarPaises();
    this.listarCodigosCIIU();
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: '',
      descripcionPantalla: '',
      pasos: [],
      // Evento en el botón volver
      change: async op =>
        await this.guardarAntesDeSalir(this.alertaModalService, this.location, op),
    };
    // Consultar si existe un trámite pendiente
    this.utilService.changeInfoPantalla(this.infoPantalla);
    this.getTramite();
  }

  getTramite() {
    const isTramiteNew: boolean = JSON.parse(sessionStorage.getItem('nuevoTramite')!);
    // Si es un trámite nuevo, se obtienen los datos del usuario de la sesión
    // y se setean los datos de sesión
    if (isTramiteNew) {
      // this.dataUsuario = JSON.parse(
      //   sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
      // );
      setTimeout(() => {
        this.setearDatosSesion();
      }, 1000);
    } else {
      // Se valida si existe un trámite pendiente por completar
      this.tramiteService
        .consultarTramitePendiente(
          Number(this.dataUsuario?.idUsuario),
          Constants.ID_ENTIDAD_SSO_LJI
        )
        .subscribe(resp => {
          if ((resp as { Id: number }).Id !== null) {
            // Se consume el servicio que obtiene el detalle del trámite
            // this.dataUsuario = undefined;
            this.consultarTramitePorID(resp.Id);
          } else {
            // this.dataUsuario = JSON.parse(
            //   sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
            // );
            setTimeout(() => {
              this.setearDatosSesion();
            }, 1000);
          }
        });
    }
  }
  // Función para mostrar alerta antes de salir de la pantalla
  async guardarAntesDeSalir(
    alertas: AlertaModalService,
    loc: Location,
    op?: () => void
  ) {
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {
          const response = await this.guardarProceso(false);
          if (response.success) {
            if (op) {
              op();
            } else {
              loc.back();
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }
  // Se setean los datos en los formularios, en el caso de que exista un trámite pendiente
  consultarTramitePorID(id: number) {
    this.idProceso = id;
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        // Formulario: información inicial e Identificación del deudor
        if (resp) {
          const codigo = resp.tipoSolicitante.codigo;
          if (codigo == 'PNC') {
            this.esPNC = true;
            resp.id ? this.idProceso = resp.id : null;
            if (resp.anexos) {
              this.archivosPrecargados = resp.anexos;
            }
            // Se valida si el país es Colombia, para eliminar las validaciones correspondientes
            const idPais = this.paises.find(
              item => item.Codigo == Constants.CODIGO_COLOMBIA
            )?.Id;
            if (resp.paisDomicilio.id == idPais) {
              this.formIDdeudor.controls['otroDepartamento'].removeValidators(Validators.required);
              this.formIDdeudor.controls['otroDepartamento'].updateValueAndValidity();
              this.formIDdeudor.controls['otroMunicipio'].removeValidators(Validators.required);
              this.formIDdeudor.controls['otroMunicipio'].updateValueAndValidity();
            }
            // Listar revisores fiscales
            this.listarRevisores();
            // Listar apoderados
            this.listarApoderados();
            // Listar contadores
            this.listarContadores();
            // Lista simple revisores fiscales
            this.listaSimpleRevisores();
            // Lista simple apoderados
            this.listaSimpleApoderados();
            // Lista simple contadores
            this.listaSimpleContadores();
            // Lista simple representales legales
            this.camposIDdeudor = this.camposIDdeudor.map((field) => {
              switch (field.name) {
                case 'typeOfDocument':
                  field.value = resp.tipoIdentificacion.id ? resp.tipoIdentificacion.id : undefined;
                  break;
                case 'numberOfDocument':
                  field.value = resp.numeroIdentificacion ? resp.numeroIdentificacion : undefined;
                  break;
                case 'nombre':
                  field.value = resp.nombreRazonSocial ? resp.nombreRazonSocial : undefined;
                  break;
                case 'codigoCIIU':
                  field.value = resp.codigoCIIU?.id ? resp.codigoCIIU.id : undefined;
                  break;
                case 'macrosector':
                  field.value = resp.macrosector?.id ? resp.macrosector.id : undefined;
                  break;
                case 'country':
                  field.value = resp.paisDomicilio.id ? resp.paisDomicilio.id : undefined;
                  break;
                case 'departament':
                  field.value = resp.departamentoDomicilio.id ? resp.departamentoDomicilio.id : undefined;
                  break;
                case 'municipality':
                  field.value = resp.municipioDomicilio.id ? resp.municipioDomicilio.id : undefined;
                  break;
                case 'otroDepartamento':
                  field.value = resp.otroDepartamento ? resp.otroDepartamento : undefined;
                  break;
                case 'otroMunicipio':
                  field.value = resp.otroMunicipio ? resp.otroMunicipio : undefined;
                  break;
                case 'direccion':
                  field.value = resp.direccionNotificacion ? resp.direccionNotificacion : undefined;
                  break;
                case 'correo':
                  field.value = resp.correoElectronicoNotificacion ? resp.correoElectronicoNotificacion : undefined;
                  break;
                case 'telefono':
                  field.value = resp.telefono ? resp.telefono : undefined;
                  break;
                case 'numeroEmpleadasMujeres':
                  field.value = resp.numeroEmpleadosMujeres ? resp.numeroEmpleadosMujeres : undefined;
                  break;
                case 'numeroEmpleadosHombres':
                  field.value = resp.numeroEmpleadosHombres ? resp.numeroEmpleadosHombres : undefined;
                  break;
              }
              return field;
            });
            // Formulario: Información de profesionales asociados al deudor
            this.camposInfoProfesionales = this.camposInfoProfesionales.map((field) => {
              switch (field.name) {
                case 'contador':
                  field.value = resp.contador.id ? resp.contador.id : undefined;
                  break;
                case 'revisorFiscal':
                  field.value = resp.revisorFiscal.id ? resp.revisorFiscal.id : undefined;
                  break;
                case 'apoderado':
                  resp.apoderado.id ? this.mostrarArchivoApoderado = true : this.mostrarArchivoApoderado = false;
                  field.value = resp.apoderado.id ? resp.apoderado.id : undefined;
                  break;
              }
              return field;
            });
            // Formulario: Supuestos de admisibilidad
            this.camposSupuestos = this.camposSupuestos.map((field) => {
              switch (field.name) {
                case 'certificoActividad':
                  field.value = resp.certificoActividad?.id ? resp.certificoActividad.id : undefined;
                  break;
              }
              return field;
            });
            // Formulario: Cumplimiento de la hipótesis de negocio en marcha
            this.camposCumplimientoHipotesis = this.camposCumplimientoHipotesis.map((field) => {
              switch (field.name) {
                case 'fechaVerificacion':
                  field.value = resp.fechaDeudorNoCumpliaHipotesisNegocio ? resp.fechaDeudorNoCumpliaHipotesisNegocio : undefined;
                  break;
              }
              return field;
            });
            // Formulario: Información financiera con corte al último día calendario del mes anterior
            this.camposInfoFinancieraMes = this.camposInfoFinancieraMes.map((field) => {
              switch (field.name) {
                case 'fechaEstadoFinancieroMesAnterior':
                  field.value = resp.fechaEstadoFinancieroMesAnterior ? resp.fechaEstadoFinancieroMesAnterior : undefined;
                  break;
                case 'valorTotalActivosMesAnterior':
                  field.value = resp.valorTotalActivosMesAnterior ? resp.valorTotalActivosMesAnterior : undefined;
                  break;
                case 'valorTotalPasivosMesAnterior':
                  field.value = resp.valorTotalPasivosMesAnterior ? resp.valorTotalPasivosMesAnterior : undefined;
                  break;
                case 'valorTotalPatrimonioMesAnterior':
                  field.value = resp.valorTotalPatrimonioMesAnterior ? resp.valorTotalPatrimonioMesAnterior : undefined;
                  break;
                case 'baseContable':
                  field.value = resp.baseContable?.id ? resp.baseContable.id : undefined;
                  break;
              }
              return field;
            });
            // Formulario: Información financiera con corte al último año anterior
            this.camposInfoFinancieraAnio = this.camposInfoFinancieraAnio.map((field) => {
              switch (field.name) {
                case 'fechaEstadoFinancieroAnioAnterior':
                  field.value = resp.fechaEstadoFinancieroAnioAnterior ? resp.fechaEstadoFinancieroAnioAnterior : undefined;
                  break;
                case 'valorTotalActivosAnioAnterior':
                  field.value = resp.valorTotalActivosAnioAnterior ? resp.valorTotalActivosAnioAnterior : undefined;
                  break;
                case 'valorTotalPasivosAnioAnterior':
                  field.value = resp.valorTotalPasivosAnioAnterior ? resp.valorTotalPasivosAnioAnterior : undefined;
                  break;
                case 'valorTotalIngresosOrdinariosAnioAnterior':
                  field.value = resp.valorTotalIngresosOrdinariosAnioAnterior ? resp.valorTotalIngresosOrdinariosAnioAnterior : undefined;
                  break;
                case 'valorTotalOtrosIngresosAnioAnterior':
                  field.value = resp.valorTotalOtrosIngresosAnioAnterior ? resp.valorTotalOtrosIngresosAnioAnterior : undefined;
                  break;
                case 'tieneIversionesSubsidiarias':
                  field.value = resp.tieneIversionesSubsidiarias ? resp.tieneIversionesSubsidiarias : undefined;
                  break;
                case 'valorTotalGananciaMetodoParticipacion':
                  field.value = resp.valorTotalGananciaMetodoParticipacion ? resp.valorTotalGananciaMetodoParticipacion : undefined;
                  break;
                case 'valorTotalGananciaMetodoAlCosto':
                  field.value = resp.valorTotalGananciaMetodoAlCosto ? resp.valorTotalGananciaMetodoAlCosto : undefined;
                  break;
                case 'valorTotalGananciaMetodoValorRazonable':
                  field.value = resp.valorTotalGananciaMetodoValorRazonable ? resp.valorTotalGananciaMetodoValorRazonable : undefined;
                  break;
              }
              return field;
            });
            // Formulario: Conjunto completo de estados financieros comparativos
            this.camposEstadosFinancieros = this.camposEstadosFinancieros.map((field) => {
              switch (field.name) {
                case 'baseContable1':
                  field.value = resp.baseContable1?.id ? resp.baseContable1.id : undefined;
                  break;
                case 'baseContable2':
                  field.value = resp.baseContable2?.id ? resp.baseContable2.id : undefined;
                  break;
                case 'baseContable3':
                  field.value = resp.baseContable3?.id ? resp.baseContable3.id : undefined;
                  break;
              }
              return field;
            });
            // Formulario: Documentos adicionales
            this.camposDocumentosAdicionales = this.camposDocumentosAdicionales.map((field) => {
              switch (field.name) {
                case 'descripcion':
                  field.value = resp.descripcion ? resp.descripcion : undefined;
                  break;
              }
              return field;
            });
          } else {
            this.esPNC = false;
            this.dataUsuario = JSON.parse(
              sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE)!
            );
            setTimeout(() => {
              this.setearDatosSesion();
            }, 1000);
          }
        }
      });
  }

  setearDatosSesion() {
    // Si es extranjero
    if (this.dataUsuario?.pais !== 1) {
      this._cuentaService.getDataPersonal(this.dataUsuario.idUsuario!).subscribe((response: any) => {
        if (response.status === 200) {
          this.dataUsuario.otroDepartamento = response.data.Otro_Departamento;
          this.dataUsuario.otroMunicipio = response.data.Otro_Municipio;
        }
        this.mapearFormularioDeudor();
      });
      this.camposIDdeudor.forEach(field => {
        if (['otroMunicipio', 'otroDepartamento'].includes(field.name)) {
          field.required = true;
        }
      });
    } else {
      this.mapearFormularioDeudor();
    }
  }

  // Se setean los datos de la persona activa en la sesión, en el caso de que no exista un trámite pendiente
  mapearFormularioDeudor() {
    const tipoDoc = this.tiposDocumento.find((item) => item.Tipo_Documento == this.dataUsuario?.tipoDocumento)?.Id;
    this.camposIDdeudor = this.camposIDdeudor.map((field: FormField) => {
      if (this.dataUsuario) {
        const idPais = this.paises.find(
          item => item.Codigo == Constants.CODIGO_COLOMBIA
        )?.Id;
        if (this.dataUsuario.pais == idPais) {
          this.formIDdeudor.controls['otroDepartamento'].removeValidators(Validators.required);
          this.formIDdeudor.controls['otroDepartamento'].updateValueAndValidity();
          this.formIDdeudor.controls['otroMunicipio'].removeValidators(Validators.required);
          this.formIDdeudor.controls['otroMunicipio'].updateValueAndValidity();
        }
        switch (field.name) {
          case 'typeOfDocument':
            field.value = tipoDoc;
            break;
          case 'numberOfDocument':
            field.value = this.dataUsuario.identificacion;
            break;
          case 'nombre':
            field.value = this.dataUsuario.primerNombre + ' ' + this.dataUsuario.primerApellido;
            break;
          case 'country':
            field.value = this.dataUsuario.pais;
            break;
          case 'departament':
            field.value = this.dataUsuario.departamento;
            break;
          case 'municipality':
            field.value = this.dataUsuario.municipio;
            break;
          case 'otroDepartamento':
            field.value = this.dataUsuario.otroDepartamento ?? '';
            break;
          case 'otroMunicipio':
            field.value = this.dataUsuario.otroMunicipio ?? '';
            break;
          case 'direccion':
            field.value = this.dataUsuario.direccion[0].Direccion_Notificacion;
            break;
          case 'correo':
            field.value = this.dataUsuario.correoElectronico;
            break;
          case 'telefono':
            field.value = this.dataUsuario.telefonoPrincipal;
            break;
        }
      }
      return field;
    })
  }
  // Se consume el servicio para obtener la lista de Macrosector
  listarMacrosector() {
    this.listaService.listaValor(Constants.MACROSECTOR).subscribe((resp) => {
      this.listaValorMacrosector = resp as ListaValorRequestDto[];
      this.listaValorMacrosector = resp.map(item => ({
        id: item.Id,
        nombreLista: item.Nombre_Lista,
        valor: item.Valor,
        otroValor: item.Otro_valor,
        estado: item.Estado,
        codigo: item.Codigo
      }));
      this.macrosector = resp.map(item => ({
        Id: item.Id ?? '',
        Nombre: item.Valor || '',
      }));
      this.initFormIDDeudor();
    });
  }
  // Se consume el servicio para obtener la lista de supuestos
  listarSupuestos() {
    this.listaService.listaValor(Constants.CESE_PAGOS).subscribe((resp) => {
      const cesacion = resp.find(item => item.Valor === Constants.CESACION_PAGOS);

      if (cesacion) {
        this.listaValorCesePagos = [{
          id: cesacion.Id,
          nombreLista: cesacion.Nombre_Lista,
          valor: cesacion.Valor,
          otroValor: cesacion.Otro_valor,
          estado: cesacion.Estado,
          codigo: cesacion.Codigo
        }];

        this.supuestos = [{
          Id: cesacion.Id ?? '',
          Nombre: cesacion.Valor || '',
        }];

        this.initFormSupuestos();
      }
    });
  }

  // Se consume el servicio para obtener la lista de base contable
  listarBaseContable() {
    this.listaService.listaValor(Constants.BASE_CONTABLE).subscribe((resp) => {
      this.listaValorBaseContable = resp as ListaValorRequestDto[];
      this.listaValorBaseContable = resp.map(item => ({
        id: item.Id,
        nombreLista: item.Nombre_Lista,
        valor: item.Valor,
        otroValor: item.Otro_valor,
        estado: item.Estado,
        codigo: item.Codigo
      }));
      this.baseContable = resp.map(item => ({
        Id: item.Id ?? '',
        Nombre: item.Valor || '',
      }));
      this.initFormInfoFinancieraMes();
      this.initFormEstadosFinancieros();
    });
  }
  // Se consume el servicio para obtener la lista de tipos de solicitante
  listarTiposSolicitante() {
    this.listaService.listaValor(Constants.ROI_TIPO_SOLICITANTE).subscribe(resp => {
      this.listaTipoSolicitante = resp;
      this.listaValorTipoSolicitante = resp as ListaValorRequestDto[];
      this.listaValorTipoSolicitante = resp.map(item => ({
        id: item.Id,
        nombreLista: item.Nombre_Lista,
        valor: item.Valor,
        otroValor: item.Otro_valor,
        estado: item.Estado,
        codigo: item.Codigo
      }));
    });
  }
  // Se consume el servicio para obtener la lista de países
  listarPaises() {
    // Se consume el servicio de listar paises
    this.listaService.getCountryList().subscribe((pais: PaisDto[]) => {
      this.paises = pais;
    });
  }
  // Se consume el servicio para obtener la lista de tipos de documento
  listaTiposDocumento() {
    this.listaService.getDocumentTypeList().subscribe((tipo: TipoDocumentoDto[]) => {
      this.tiposDocumento = tipo;
    });
  }
  // Se consume el servicio para obtener la lista de códigos CIIU
  listarCodigosCIIU() {
    this.listaService.listaValor(Constants.CODIGO_CIIU).subscribe(response => {
      this.listaValorCodigoCIIU = response as ListaValorRequestDto[];
      this.listaValorCodigoCIIU = response.map(item => ({
        id: item.Id,
        nombreLista: item.Nombre_Lista,
        valor: item.Valor,
        otroValor: item.Otro_valor,
        estado: item.Estado,
        codigo: item.Codigo
      }));
      const data = response as ListaValorResponseDto[];
      this.camposIDdeudor = this.camposIDdeudor.map(field => {
        if (field.name === 'codigoCIIU') {
          field.options = data.map((item: ListaValorResponseDto) => ({
            Id: item.Id!,
            Nombre: `${item.Otro_valor!} - ${item.Valor!}`,
          }));
        }
        return field;
      });
    });
  }
  // Se consume el servicio de listar revisores fiscales
  listarRevisores() {
    this.liqJudicialService.listaRevisores(1, Constants.CODIGO_LJI,
      this.idTipoSolicitante, this.esPNC ? this.idProceso : null)
      .subscribe((resp: TablaProfesionalesDTO) => {
        this.datosRevisores = resp.datos;
      });
  }
  // Se consume el servicio de listar apoderados
  listarApoderados() {
    this.liqJudicialService.listaApoderados(1, Constants.CODIGO_LJI,
      this.idTipoSolicitante, this.esPNC ? this.idProceso : null)
      .subscribe((resp: TablaProfesionalesDTO) => {
        this.datosApoderados = resp.datos;
      });
  }
  // Se consume el servicio de listar contadores
  listarContadores() {
    this.liqJudicialService.listaContadores(1, Constants.CODIGO_LJI,
      this.idTipoSolicitante, this.esPNC ? this.idProceso : null)
      .subscribe((resp: TablaProfesionalesDTO) => {
        this.datosContadores = resp.datos;
      });
  }
  // Se consume el servicio de listar revisores fiscales para el paso de profesionales asociados al deudor
  listaSimpleRevisores() {
    this.liqJudicialService.listaSimpleRevisores(Constants.CODIGO_LJI,
      this.idTipoSolicitante, this.esPNC ? this.idProceso : null)
      .subscribe((resp: FormFieldOption[]) => {
        this.revisores = resp;
        this.revisores = resp;
        this.camposInfoProfesionales = this.camposInfoProfesionales.map((field) => {
          if (field.name === 'revisorFiscal') {
            field.options = this.revisores;
          }
          return field;
        });
      });
  }
  // Se consume el servicio de listar apoderados para el paso de profesionales asociados al deudor
  listaSimpleApoderados() {
    this.liqJudicialService.listaSimpleApoderados(Constants.CODIGO_LJI,
      this.idTipoSolicitante, this.esPNC ? this.idProceso : null)
      .subscribe((resp: FormFieldOption[]) => {
        this.apoderados = resp;
        this.camposInfoProfesionales = this.camposInfoProfesionales.map((field) => {
          if (field.name === 'apoderado') {
            field.options = this.apoderados;
          }
          return field;
        });
      });
  }
  // Se consume el servicio de listar contadores para el paso de profesionales asociados al deudor
  listaSimpleContadores() {
    this.liqJudicialService.listaSimpleContadores(Constants.CODIGO_LJI,
      this.idTipoSolicitante, this.esPNC ? this.idProceso : null)
      .subscribe((resp: FormFieldOption[]) => {
        this.contadores = resp;
        this.camposInfoProfesionales = this.camposInfoProfesionales.map((field) => {
          if (field.name === 'contador') {
            field.options = this.contadores;
          }
          return field;
        });
      });
  }
  // Se declaran los campos del formulario de liquidación judicial persona natural comerciante
  initFormIDDeudor() {
    this.camposIDdeudor = [
      // Sección: Información inicial
      {
        name: 'tipoSolicitante',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['tipo_solicitante'],
        type: 'text',
        required: false,
        visible: true,
        width: '6',
        disabled: true,
        value: 'Persona Natural Comerciante'
      },
      {
        name: 'tipoSolicitud',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_solicitud'],
        type: 'text',
        required: false,
        visible: true,
        width: '6',
        disabled: true,
        value: 'Liquidación Judicial'
      },
      {
        name: 'normaAplicable',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['norma_aplicable'],
        placeholder: '',
        type: 'text',
        required: false,
        width: '6',
        disabled: true,
        value: 'Ley 1116 de 2006'
      },
      // Sección: Identificación del deudor (Artículo 2, Ley 1116 de 2006)
      {
        isSubtitle: true,
        subtitleText: this.roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][1],
        name: 'subTitle',
        label: '',
        type: 'text',
        visible: true,
      },
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'nombre',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['nombre'],
        placeholder: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['nombre'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'codigoCIIU',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['ciiu'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'macrosector',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['macrosector'],
        type: 'select',
        required: true,
        options: this.macrosector,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '12',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
      {
        name: 'numeroEmpleadasMujeres',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['empleadas_mujeres'],
        type: 'number',
        required: true,
        placeholder: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['empleadas_mujeres'],
        width: '6',
        visible: true,
        maxLength: '5',
        validation: [
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_numero'],
          pattern: this.comunText['negativo']
        },
      },
      {
        name: 'numeroEmpleadosHombres',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['empleados_hombres'],
        type: 'number',
        required: true,
        placeholder: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['empleados_hombres'],
        width: '6',
        visible: true,
        maxLength: '5',
        validation: [
          Validators.pattern(Constants.REGEX_TELEFONO)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_numero'],
          pattern: this.comunText['negativo']
        },
      },
      // Archivo: Certificado de Matrícula Mercantil
    ]
  }
  // Revisor fiscal
  initFormTipoRevisor() {
    this.campoTipoRevisor = [
      {
        name: 'tipoPersonaRevisor',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_revisor'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: 'Natural' },
          { Id: 2, Nombre: 'Jurídica' },
        ],
        width: '6',
        visible: true,
        errorMessages: { required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_revisor_required'] }
      },
    ];
  }
  initFormRevisorPN() {
    this.camposRevisorPN = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        width: '6',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_ADULTO} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  initFormRevisorPJ() {
    this.camposRevisorPJ = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '2',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  // Apoderado
  initFormTipoApoderado() {
    this.campoTipoApoderado = [
      {
        name: 'tipoPersonaApoderado',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_apoderado'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: 'Natural' },
          { Id: 2, Nombre: 'Jurídica' },
        ],
        width: '6',
        visible: true,
        errorMessages: { required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_apoderado_required'] }
      },
    ];
  }
  initFormApoderadoPN() {
    this.camposApoderadoPN = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        width: '6',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_ADULTO} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  initFormApoderadoPJ() {
    this.camposApoderadoPJ = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '2',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }
  // Contador
  initFormTipoContador() {
    this.campoTipoContador = [
      {
        name: 'tipoPersonaContador',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_contador'],
        type: 'select',
        required: true,
        options: [
          { Id: 1, Nombre: 'Natural' },
          { Id: 2, Nombre: 'Jurídica' },
        ],
        width: '6',
        visible: true,
        errorMessages: { required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_contador_required'] }
      },
    ];
  }
  initFormContadorPN() {
    this.camposContadorPN = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '1',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'primerNombre',
        label: this.comunText['primer-nombre'],
        placeholder: this.comunText['primer-nombre-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-nombre-required'],
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'segundoNombre',
        label: this.comunText['segundo-nombre'],
        placeholder: this.comunText['segundo-nombre-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['nombre-minlength'],
          maxlength: this.comunText['nombre-maxlength'],
          pattern: this.comunText['nombre-pattern'],
        },
      },
      {
        name: 'primerApellido',
        label: this.comunText['primer-apellido'],
        placeholder: this.comunText['primer-apellido-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['primer-apellido-required'],
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'segundoApellido',
        label: this.comunText['segundo-apellido'],
        placeholder: this.comunText['segundo-apellido-placeholder'],
        type: 'text',
        required: false,
        width: '6',
        validation: [
          Validators.minLength(2),
          Validators.maxLength(25),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          minlength: this.comunText['apellido-minlength'],
          maxlength: this.comunText['apellido-maxlength'],
          pattern: this.comunText['apellido-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'fechaNacimiento',
        label: this.comunText['fecha-nacimiento'],
        type: 'date',
        required: false,
        width: '6',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          edadRequerida: `${this.comunText['fecha-nacimiento-edad-requerida']} ${Constants.ANIOS_ADULTO} ${this.comunText['fecha-nacimiento-anio']}.`,
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }

  initFormContadorPJ() {
    this.camposContadorPJ = [
      {
        name: 'typeOfDocument',
        label: this.comunText['tipo-identificacion'],
        type: 'select',
        required: true,
        options: [],
        width: '6',
        visible: true,
        errorMessages: { required: this.comunText['tipo-identificacion-required'] },
        personTypeId: '2',
      },
      {
        name: 'numberOfDocument',
        label: this.comunText['numero-identificacion'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        errorMessages: {
          required: this.comunText['numero-identificacion-required'],
        },
      },
      {
        name: 'razonSocial',
        label: this.comunText['razon-social'],
        placeholder: this.comunText['razon-social-placeholder'],
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.minLength(3),
          Validators.maxLength(100),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        ],
        errorMessages: {
          required: this.comunText['razon-social-required'],
          minlength: this.comunText['razon-social-minlength'],
          maxlength: this.comunText['razon-social-maxlength'],
          pattern: this.comunText['razon-social-pattern'],
        },
      },
      {
        name: 'country',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pais-required'],
        },
      },
      {
        name: 'departament',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['departamento-required'],
        },
      },
      {
        name: 'municipality',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio'],
        type: 'select',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['municipio-required'],
        },
      },
      {
        name: 'otroDepartamento',
        label: this.comunText['departament'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['department-required'],
          maxlength: this.comunText['department-maxlength'],
          pattern: this.comunText['department-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'otroMunicipio',
        label: this.comunText['municipality'],
        placeholder: '',
        type: 'text',
        required: true,
        width: '6',
        validation: [
          Validators.maxLength(30),
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
        ],
        errorMessages: {
          required: this.comunText['municipality-required'],
          maxlength: this.comunText['municipality-maxlength'],
          pattern: this.comunText['municipality-pattern']
        },
        dependsOn: 'country',
        visibilityCondition: value => {
          // Busca el país Colombia en la lista
          const paisColombia = this.paises.find(
            item => item.Codigo === Constants.CODIGO_COLOMBIA
          );
          // Si value es undefined, no mostrar el campo
          if (value === undefined) {
            return false;
          }
          // Mostrar el campo si el valor no corresponde al Id de Colombia
          return paisColombia ? value !== paisColombia.Id : true;
        }
      },
      {
        name: 'direccion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(10),
          Validators.maxLength(40),
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-required'],
          minlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-minlength'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['direccion-maxlength'],
          pattern:
            this.comunText['direccion-notificacion-judicial-pattern'],
        }
      },
      {
        name: 'correo',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo'],
        type: 'email',
        required: true,
        placeholder: this.comunText['email-placeholder'],
        width: '6',
        visible: true,
        validation: [
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          Validators.maxLength(100),
        ],
        errorMessages: {
          required:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-required'],
          pattern:
            this.comunText['email-pattern'],
          maxlength:
            this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['correo-maxlength'],
        },
      },
      {
        name: 'telefono',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['telefono'],
        type: 'text',
        required: true,
        width: '6',
        visible: true,
        validation: [
          Validators.minLength(6),
          Validators.maxLength(15),
          Validators.pattern(Constants.REGEX_TELEFONO),
        ],
        errorMessages: {
          required: this.comunText['telefono-required'],
          pattern: this.comunText['telefono-pattern'],
          minlength: this.comunText['telefono-minlength'],
          maxlength: this.comunText['telefono-maxlength'],
        },
      },
    ];
  }
  initFormProfesionales() {
    this.camposInfoProfesionales = [
      // Sección: Información de profesionales asociados al deudor
      {
        name: 'contador',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador'],
        type: 'select',
        required: true,
        options: this.contadores,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'revisorFiscal',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal'],
        type: 'select',
        required: false,
        options: this.revisores,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'apoderado',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado'],
        type: 'select',
        required: false,
        options: this.apoderados,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      // Archivo: Poder al abogado para realizar la solicitud
    ]
  }
  initFormMemoriaExplicativa() {
    // Sección: Memoria explicativa de las causas de insolvencia
  }
  initFormSupuestos() {
    this.camposSupuestos = [
      // Sección: Supuestos de admisibilidad
      {
        name: 'certificoActividad',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['certificado_desarrollo_actividad'],
        type: 'select',
        required: true,
        options: this.supuestos,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
        },
      },
      // Archivo: Certificación que acredite la cesación de pagos y Anexo de la certificación de cesación de pagos
    ]
  }
  initFormCumplimiento() {
    this.camposCumplimientoHipotesis = [
      // Sección: Cumplimiento de la hipótesis de negocio en marcha
      {
        name: 'fechaVerificacion',
        label: this.sociedadText['fecha-verificacion'],
        type: 'date',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.sociedadText['fecha-verificacion-required'],
        },
        isMaxDate: true
      },
    ]
  }
  initFormInfoFinancieraMes() {
    this.camposInfoFinancieraMes = [
      // Sección: Información financiera con corte al último día calendario del mes anterior
      {
        name: 'fechaEstadoFinancieroMesAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['fecha_estado_financiero_mes_anterior'],
        type: 'date',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
        isMaxDate: true
      },
      {
        name: 'valorTotalActivosMesAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['activos_netos_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['activos_netos_mes_anterior_required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
      },
      {
        name: 'valorTotalPasivosMesAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_netos_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_netos_mes_anterior_required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
      },
      {
        name: 'valorTotalPatrimonioMesAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['patrimonio_mes_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
      },
      {
        name: 'baseContable',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['base'],
        type: 'select',
        options: this.baseContable,
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['base-required'],
        },
      },
      // Archivos: Estado de los activos netos en liquidación del mes anterior,
      // Estado de cambios en los activos netos en liquidación del mes anterior,
      // Conciliación entre los saldos del estado inicial de los activos netos en liquidación y los saldos del último estado de situación financiera del mes anterior
      // Notas a estados financieros y certificación a los estados financieros del mes anterior
      // Dictamen del revisor fiscal del mes anterior (Si aplica)
    ]
  }
  initFormInfoFinancieraAnio() {
    this.camposInfoFinancieraAnio = [
      // Sección: Información financiera con corte al último año anterior
      {
        name: 'fechaEstadoFinancieroAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['fecha_estado_financiero_anio_anterior'],
        type: 'date',
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
        isMaxDate: true
      },
      {
        name: 'valorTotalActivosAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['activos_netos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['activos_netos_anio_anterior_required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
      },
      {
        name: 'valorTotalPasivosAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_netos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['pasivos_netos_anio_anterior_required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
      },
      {
        name: 'valorTotalIngresosOrdinariosAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['ingresos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
      },
      {
        name: 'valorTotalOtrosIngresosAnioAnterior',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['otros_ingresos_anio_anterior'],
        type: 'decimal',
        required: true,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
      },
      {
        name: 'tieneIversionesSubsidiarias',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['tiene_iversiones_subsidiarias'],
        type: 'radio',
        required: true,
        width: '6',
        options: [
          { Nombre: this.comunText['opcion-si'], Id: 1 },
          { Nombre: this.comunText['opcion-no'], Id: 2 },
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required']
        },
      },
      {
        name: 'valorTotalGananciaMetodoParticipacion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_participacion'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'valorTotalGananciaMetodoAlCosto',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_costo'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
      {
        name: 'valorTotalGananciaMetodoValorRazonable',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['valor_ganancias_razonable'],
        type: 'decimal',
        required: false,
        width: '6',
        visible: true,
        maxLength: '20',
        validation: [
          Validators.pattern(Constants.REGEX_DECIMAL)
        ],
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['campo-required'],
          maxlength: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['maxlength_valor_monetario'],
          pattern: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['numero_decimal']
        },
        dependsOn: 'tieneIversionesSubsidiarias',
        visibilityCondition: value => value == 1,
      },
    ]
  }
  initFormEstadosFinancieros() {
    this.camposEstadosFinancieros = [
      // Sección: Conjunto completo de estados financieros comparativos
      {
        name: 'baseContable1',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['base'] + ' ' + this.lastYear.toString(),
        type: 'select',
        options: this.baseContable,
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['base-required'],
        },
      },
      {
        name: 'baseContable2',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['base'] + ' ' + this.yearBeforeLast.toString(),
        type: 'select',
        options: this.baseContable,
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['base-required'],
        },
      },
      {
        name: 'baseContable3',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['base'] + ' ' + this.twoYearsAgo.toString(),
        type: 'select',
        options: this.baseContable,
        required: true,
        width: '6',
        visible: true,
        errorMessages: {
          required: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['base-required'],
        },
      },
      // Archivos: Estados financieros del último año (2023),
      // Notas a estados financieros y certificación a los estados financieros del último año (2023)
      // Dictamen del revisor fiscal del último año (2023) (Si aplica)
      // Estados financieros del antepenúltimo año (2021)
      // Notas a estados financieros y certificación a los estados financieros del antepenúltimo año (2021)
      // Dictamen del revisor fiscal del antepenúltimo año (2021) (Si aplica)
    ]
  }
  initFormInventario() {
    // Sección: Inventario de activos y pasivos netos con corte al último día del mes anterior
    // Archivos: Inventario de activos netos del mes anterior
    // Inventario de pasivos netos del mes anterior
  }
  initFormOtrosDocumentos() {
    // Sección: Otros documentos requeridos
    // Archivo: Certificación de llevar contabilidad regular
  }
  initFormDocumentosAdicionales() {
    // Sección: Documentos adicionales
    // Archivo: archivo
    this.camposDocumentosAdicionales = [
      {
        name: 'descripcion',
        label: this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['descripcion'],
        type: 'textarea',
        required: false,
        width: '6',
        noConvertToUpperCase: true,
        validation: [
          Validators.pattern(Constants.REGEX_ACTA_PROTESTA),
        ],
        errorMessages: {
          pattern: this.comunText['campo-descripcion'],
        },
      },
    ]
  }
  initColumnsRevisor() {
    this.columnasRevisor = [
      {
        field: 'persona.Tipo_Documento.Descripcion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'persona.Identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'nombre',
        title: this.comunText['nombre_razon_social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
    // Acciones
    this.accionesRevisor = [
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }
  initColumnsApoderado() {
    this.columnasApoderado = [
      {
        field: 'persona.Tipo_Documento.Descripcion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'persona.Identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'nombre',
        title: this.comunText['nombre_razon_social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
    // Acciones
    this.accionesApoderado = [
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }
  initColumnsContador() {
    this.columnasContador = [
      {
        field: 'persona.Tipo_Documento.Descripcion',
        title: this.comunText['tipo-documento'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'persona.Identificacion',
        title: this.comunText['number-document'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'nombre',
        title: this.comunText['nombre_razon_social'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ];
    // Acciones
    this.accionesContador = [
      {
        type: 'button',
        title: '',
        icon: 'trash-o',
        idAccion: '1',
      },
    ];
  }
  capturarFormIDDeudor(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formIDdeudor = evento.form;
    if (evento.controlName == 'country') {
      // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].setValue('');
        evento.form.controls['otroMunicipio'].setValue('');
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
  }

  // Función que construye el JSON para enviar al seervicio
  construirJSON(esEnviar: boolean): LiquidacionJudicialDTO {
    // Revisor
    // Si no existen revisores almacenados, se envían los datos del formulario, si existen
    // revisores almacenados previamente, se envían los datos que vienen del servicio de listar revisores
    let arrayRevisores: ProfesionalDTO[] = [];
    if (this.datosRevisores.length === 0) {
      arrayRevisores = [
        this.construirJSONRevisor()
      ]
    } else {
      arrayRevisores = this.procesarArrayRevisores();
    }
    // Apoderado
    // Si no existen apoderados almacenados, se envían los datos del formulario, si existen
    // apoderados almacenados previamente, se envían los datos que vienen del servicio de listar apoderados
    let arrayApoderados: ProfesionalDTO[] = [];
    if (this.datosApoderados.length === 0) {
      arrayApoderados = [
        this.construirJSONApoderado()
      ]
    } else {
      arrayApoderados = this.procesarArrayApoderados();
    }
    // Contador
    // Si no existen contadores almacenados, se envían los datos del formulario, si existen
    // contadores almacenados previamente, se envían los datos que vienen del servicio de listar contadores
    let arrayContadores: ProfesionalDTO[] = [];
    if (this.datosContadores.length === 0) {
      arrayContadores = [
        this.construirJSONContador()
      ]
    } else {
      arrayContadores = this.procesarArrayContadores();
    }
    const proceso: LiquidacionJudicialDTO = {
      idCreador: this.idUsuario!,
      id: this.esPNC ? this.idProceso : null,
      tipoSolicitante: this.retornarListaValor('tipoSolicitante'),
      idTipoTramite: Constants.ID_ENTIDAD_SSO_LJI,
      normaAplicable: 'Ley 1116 de 2006',
      tipoIdentificacion: {
        id: this.formIDdeudor.controls['typeOfDocument']?.value
      },
      numeroIdentificacion: this.formIDdeudor.controls['numberOfDocument']?.value,
      nombreRazonSocial: this.formIDdeudor.controls['nombre']?.value,
      codigoCIIU: this.retornarListaValor('codigoCIIU'),
      macrosector: this.retornarListaValor('macrosector'),
      paisDomicilio: {
        id: this.formIDdeudor.controls['country']?.value
      },
      departamentoDomicilio: {
        id: this.formIDdeudor.controls['departament']?.value
      },
      municipioDomicilio: {
        id: this.formIDdeudor.controls['municipality']?.value
      },
      otroMunicipio: this.formIDdeudor.controls['otroMunicipio']?.value,
      otroDepartamento: this.formIDdeudor.controls['otroDepartamento']?.value,
      direccionNotificacion: this.formIDdeudor.controls['direccion']?.value,
      correoElectronicoNotificacion: this.formIDdeudor.controls['correo']?.value,
      telefono: this.formIDdeudor.controls['telefono']?.value,
      numeroEmpleadosMujeres: this.formIDdeudor.controls['numeroEmpleadasMujeres']?.value,
      numeroEmpleadosHombres: this.formIDdeudor.controls['numeroEmpleadosHombres']?.value,
      contador: {
        id: this.formInfoProfesionales.controls['contador']?.value
      },
      revisorFiscal: {
        id: this.formInfoProfesionales.controls['revisorFiscal']?.value
      },
      idApoderado: this.formInfoProfesionales.controls['apoderado']?.value,
      certificoActividad: this.retornarListaValor('certificoActividad'),
      fechaDeudorNoCumpliaHipotesisNegocio: this.formCumplimiento.controls['fechaVerificacion']?.value,
      fechaEstadoFinancieroMesAnterior: this.formInfoFinancieraMes.controls['fechaEstadoFinancieroMesAnterior']?.value,
      valorTotalActivosMesAnterior: this.formInfoFinancieraMes.controls['valorTotalActivosMesAnterior']?.value,
      valorTotalPasivosMesAnterior: this.formInfoFinancieraMes.controls['valorTotalPasivosMesAnterior']?.value,
      valorTotalPatrimonioMesAnterior: this.formInfoFinancieraMes.controls['valorTotalPatrimonioMesAnterior']?.value,
      baseContable: this.retornarListaValor('baseContable'),
      fechaEstadoFinancieroAnioAnterior: this.formInfoFinancieraAnio.controls['fechaEstadoFinancieroAnioAnterior']?.value,
      valorTotalActivosAnioAnterior: this.formInfoFinancieraAnio.controls['valorTotalActivosAnioAnterior']?.value,
      valorTotalPasivosAnioAnterior: this.formInfoFinancieraAnio.controls['valorTotalPasivosAnioAnterior']?.value,
      valorTotalIngresosOrdinariosAnioAnterior: this.formInfoFinancieraAnio.controls['valorTotalIngresosOrdinariosAnioAnterior']?.value,
      valorTotalOtrosIngresosAnioAnterior: this.formInfoFinancieraAnio.controls['valorTotalOtrosIngresosAnioAnterior']?.value,
      tieneIversionesSubsidiarias: this.formInfoFinancieraAnio.controls['tieneIversionesSubsidiarias']?.value,
      valorTotalGananciaMetodoParticipacion: this.formInfoFinancieraAnio.controls['valorTotalGananciaMetodoParticipacion']?.value,
      valorTotalGananciaMetodoAlCosto: this.formInfoFinancieraAnio.controls['valorTotalGananciaMetodoAlCosto']?.value,
      valorTotalGananciaMetodoValorRazonable: this.formInfoFinancieraAnio.controls['valorTotalGananciaMetodoValorRazonable']?.value,
      baseContable1: this.retornarListaValor('baseContable1'),
      baseContable2: this.retornarListaValor('baseContable2'),
      baseContable3: this.retornarListaValor('baseContable3'),
      descripcion: this.formDocumentosAdicionales.controls['descripcion']?.value,
      enviar: esEnviar,
      revisorFiscalMul: arrayRevisores,
      multiplesApoderados: arrayApoderados,
      contadorMul: arrayContadores
    }
    return proceso;
  }
  // Función que consume el servicio de guardar proceso
  async guardarProceso(esEnviar: boolean): Promise<{ success: boolean; message?: string }> {
    this.enviarEntidad = esEnviar;
    let proceso = this.construirJSON(esEnviar);
    try {
      const response = await firstValueFrom(
        this.liqJudicialService.liqJudicialPNC(proceso)
      );
      if (response.success && response.data.Id) {
        this.idProceso = response.data.Id;
        setTimeout(() => {
          this.enviarArchivos = true;
        }, 3000);
      }
      if (!esEnviar) {
        await this.alertaModalService.exito(
          this.alertaText['solicitud-pendiente-finalizar'],
          this.alertaText['liq-judicial']['tramite-guardado-mensaje']
        );
        if (response.success && response.data.Id) {
          return { success: true };
        } else {
          return { success: false };
        }
      } else {
        await this.alertaModalService.exito(
          this.alertaText['proceso-enviado'],
          this.alertaText['liq-judicial']['tramite-enviado'].replace('{{entidad}}', this.entidad),
        );
        this.router.navigate(['/expediente']);
        return { success: true };
      }
    } catch (e) {
      return { success: false };
    }
  }

  get esFormularioInvalido(): boolean {
    return this.formTipoRevisor?.invalid
      || this.formRevisorPN?.invalid
      || this.formRevisorPJ?.invalid
      || this.formTipoApoderado?.invalid
      || this.formApoderadoPN?.invalid
      || this.formApoderadoPJ?.invalid
      || this.formTipoContador?.invalid
      || this.formContadorPN?.invalid
      || this.formContadorPJ?.invalid
      || false;
  }


  capturarFormProfesionales(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formInfoProfesionales = evento.form;
    if (evento.controlName === 'apoderado') {
      if (evento.controlValue !== undefined) {
        this.mostrarArchivoApoderado = true;
      } else {
        this.mostrarArchivoApoderado = false;
      }
    }
  }

  capturarFormSupuestos(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formSupuestos = evento.form;
  }

  capturarFormCumplimiento(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formCumplimiento = evento.form;
  }

  capturarFormInfoFinancieraMes(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formInfoFinancieraMes = evento.form;
  }

  capturarFormInfoFinancieraAnio(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formInfoFinancieraAnio = evento.form;
  }

  capturarFormDocumentosAdicionales(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formDocumentosAdicionales = evento.form;
  }

  capturarEstadosFinancieros(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formEstadosFinancieros = evento.form
  }

  protected readonly Constants = Constants;

  // Documentos
  subirArchivo(subio: any) {
    this.enviarArchivos = false;
  }

  // Función que almacena los archivos requeridos por cada uno de los pasos
  validarArchivosRequeridos(evento: { archivos: TipoAnexoTipoTramiteDto[]; paso: number }) {
    switch (evento.paso) {
      case 1:
        this.idsFilesPasoUno = this.buscarRequeridos(evento.archivos);
        break;
      case 2:
        this.idsFilesPasoDos = this.buscarRequeridos(evento.archivos);
        break;
      case 3:
        this.idsFilesPasoTres = this.buscarRequeridos(evento.archivos);
        break;
      case 4:
        this.idsFilesPasoCuatro = this.buscarRequeridos(evento.archivos);
        break;
      case 5:
        this.idsFilesPasoCinco = this.buscarRequeridos(evento.archivos);
        break;
      case 6:
        this.idsFilesPasoSeis = this.buscarRequeridos(evento.archivos);
        break;
      case 7:
        this.idsFilesPasoSiete = this.buscarRequeridos(evento.archivos);
        break;
      case 8:
        this.idsFilesPasoOcho = this.buscarRequeridos(evento.archivos);
        break;
    }
  }

  // Función que retorna los archivos con la prppiedad de requerido = true
  buscarRequeridos(archivos: TipoAnexoTipoTramiteDto[]) {
    archivos = archivos.filter(
      (anexo: any) => anexo.requerido === true
    );
    return archivos;
  }
  // Función que captura y almacena los archivos cargados
  validarArchivosCargados(archivos: ArchivoItemDto[], paso: number) {
    switch (paso) {
      case 1:
        this.archivosCargadosPasoUno = archivos;
        break;
      case 2:
        this.archivosCargadosPasoDos = archivos;
        break;
      case 3:
        this.archivosCargadosPasoTres = archivos;
        break;
      case 4:
        this.archivosCargadosPasoCuatro = archivos;
        break;
      case 5:
        this.archivosCargadosPasoCinco = archivos;
        break;
      case 6:
        this.archivosCargadosPasoSeis = archivos;
        break;
      case 7:
        this.archivosCargadosPasoSiete = archivos;
        break;
      case 8:
        this.archivosCargadosPasoOcho = archivos;
        break;
    }
  }
  // Función que verifica si los archivos requeridos están cargados y si el formulario es válido
  validarDocumentosObligatorios(form: FormGroup | undefined, paso: number): {
    valido: boolean,
    error?: string
  } {
    let checkAnexos: boolean = false;
    let formulario: boolean | undefined = false;
    let anexosRequeridosIds: any;
    switch (paso) {
      case 1:
        anexosRequeridosIds = this.idsFilesPasoUno.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.validarAnexos(this.archivosCargadosPasoUno, anexosRequeridosIds);
        formulario = form?.valid;
        break;
      case 2:
        anexosRequeridosIds = this.idsFilesPasoDos.map(
          (anexo: any) => anexo.id
        );
        let tieneApoderado = form?.controls['apoderado'].value;
        tieneApoderado === null ? checkAnexos = true
          : checkAnexos = this.validarAnexos(this.archivosCargadosPasoDos, anexosRequeridosIds);
        formulario = form?.valid;
        break;
      case 3:
        anexosRequeridosIds = this.idsFilesPasoTres.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.validarAnexos(this.archivosCargadosPasoTres, anexosRequeridosIds);
        formulario = true;
        break;
      case 4:
        anexosRequeridosIds = this.idsFilesPasoCuatro.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.validarAnexos(this.archivosCargadosPasoCuatro, anexosRequeridosIds);
        formulario = form?.valid;
        break;
      case 5:
        anexosRequeridosIds = this.idsFilesPasoCinco.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.validarAnexos(this.archivosCargadosPasoCinco, anexosRequeridosIds);
        formulario = form?.valid;
        break;
      case 6:
        anexosRequeridosIds = this.idsFilesPasoSeis.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.validarAnexos(this.archivosCargadosPasoSeis, anexosRequeridosIds);
        formulario = form?.valid;
        break;
      case 7:
        anexosRequeridosIds = this.idsFilesPasoSiete.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.validarAnexos(this.archivosCargadosPasoSiete, anexosRequeridosIds);
        formulario = true;
        break;
      case 8:
        anexosRequeridosIds = this.idsFilesPasoOcho.map(
          (anexo: any) => anexo.id
        );
        checkAnexos = this.validarAnexos(this.archivosCargadosPasoOcho, anexosRequeridosIds);
        formulario = true;
        break;
    }
    if (!formulario) {
      return { valido: false, error: Constants.FORM_INVALID };
    }
    if (!checkAnexos) {
      return { valido: false, error: Constants.ANEXOS_INCOMPLETOS };
    }
    return { valido: true };
  }

  // Función que valida si los archivos anexados, corresponden a los archivos requeridos
  validarAnexos(archivosCargados: ArchivoItemDto[], ids: number[]): boolean {
    let requeridosFull: number = 0;
    let cantidadRequeridos: number = ids.length;
    ids.forEach((elemento: number) => {
      archivosCargados.forEach((anexo: ArchivoItemDto) => {
        if (elemento == anexo.item.id) {
          if (anexo.files.length > 0) {
            requeridosFull++;
          } else {
            requeridosFull--;
          }
        }
      });
    });
    if (requeridosFull == cantidadRequeridos) {
      return true;
    } else {
      return false;
    }
  }
  // Función que retorna los documentos anexados por pasos
  validarAnexosPrecargados(paso: number): AnexoPrecargaResponseDto[] {
    return this.archivosPrecargados.filter(
      archivo =>
        archivo.tipoAnexoTipoTramite.orden == paso
    );
  }

  validarFormularios(): boolean | undefined {
    if (this.validarDocumentosObligatorios(this.formIDdeudor, 1).valido
      && (this.datosRevisores.length > 0 && this.datosContadores.length > 0)
      && this.validarDocumentosObligatorios(this.formInfoProfesionales, 2).valido
      && this.validarPasoTres().valido
      && this.formCumplimiento?.valid
      && this.validarDocumentosObligatorios(this.formInfoFinancieraMes, 5).valido
      && this.formInfoFinancieraAnio?.valid
      && this.validarDocumentosObligatorios(this.formEstadosFinancieros, 6).valido
      && this.validarDocumentosObligatorios(this.formInventario, 7).valido
      && this.validarDocumentosObligatorios(this.formOtrosDocumentos, 8).valido
      && this.formDocumentosAdicionales.valid) {
      return true;
    } else {
      return false;
    }

  }

  validarPasoTres(): { valido: boolean, error?: string } {
    const admisibilidad = this.validarDocumentosObligatorios(this.formSupuestos, 4);
    if (!admisibilidad.valido) {
      return { valido: false, error: admisibilidad.error };
    }
    const fileMemoriaExplicativa = this.validarDocumentosObligatorios(this.formMemoriaExplicativa, 3);
    if (!fileMemoriaExplicativa.valido) {
      return { valido: false, error: fileMemoriaExplicativa.error };
    }
    return { valido: true };
  }

  onContinue(form: FormGroup, paso: number, event: any) {
    const result = this.validarDocumentosObligatorios(form, paso);

    if (!result.valido) {
      if (result.error === Constants.FORM_INVALID) {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['form_invalid']
        );
        form.markAllAsTouched();
        return;
      }

      if (result.error === Constants.ANEXOS_INCOMPLETOS) {
        this.alertaModalService.error(
          this.alertaText['error'],
          this.alertaText['archivos_obligatorios']
        );
        return;
      }

      return;
    }
    // si es válido → seguir flujo JS
    nextItemAdvanceLineIHorizonal(event);
  }

  onContinueRevisoresContadores(event: any) {
    if (this.datosRevisores.length == 0
      || this.datosContadores.length == 0) {
      this.personaComponentes.forEach((comp: FormComponent) => {
        comp.marcarTodoComoTocado();
      });
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    // si todo es válido → avanzar
    nextItemAdvanceLineIHorizonal(event);
  }

  onContinuePasoTres(event: any) {
    const result = this.validarPasoTres();

    if (!result.valido) {

      switch (result.error) {

        case Constants.FORM_INVALID:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['form_invalid']
          );
          this.formSupuestos.markAllAsTouched();
          return;

        case Constants.ANEXOS_INCOMPLETOS:
          this.alertaModalService.error(
            this.alertaText['error'],
            this.alertaText['archivos_obligatorios']
          );
          return;
      }

      return;
    }

    nextItemAdvanceLineIHorizonal(event);
  }

  onContinueCumplimiento(event: any) {
    if (this.formCumplimiento.invalid) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      this.formCumplimiento.markAllAsTouched();
      return;
    }
    // Todo válido → ejecutar script JS externo
    nextItemAdvanceLineIHorizonal(event);
  }

  onContinueInfoFinanciera(event: any) {
    if (this.formInfoFinancieraAnio.invalid) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      this.formInfoFinancieraAnio.markAllAsTouched();
      return;
    }
    // Todo válido → ejecutar script JS externo
    nextItemAdvanceLineIHorizonal(event);
  }


  onContinueFinalizar(event: any) {
    const esValido = this.validarFormularios();

    if (!esValido) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }
    // Todo está OK → ejecutar el submit real
    this.guardarProceso(true);
  }
  capturarFormRevisorPN(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formRevisorPN = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
  }

  capturarFormRevisorPJ(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formRevisorPJ = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
  }

  capturarFormApoderadoPN(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formApoderadoPN = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
  }

  capturarFormApoderadoPJ(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formApoderadoPJ = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
  }

  capturarFormContadorPN(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formContadorPN = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
  }

  capturarFormContadorPJ(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    setTimeout(() => {
      this.formContadorPJ = evento.form;
    }, 100);
    // Se verifica si el país seleccionado es Colombia, para setear las validaciones correspondientes a los campos
    if (evento.controlName == 'country') {
      const idPais = this.paises.find(
        item => item.Codigo == Constants.CODIGO_COLOMBIA
      )?.Id;
      if (evento.form.controls['country'].value == idPais) {
        evento.form.controls['departament'].addValidators(Validators.required);
        evento.form.controls['departament'].updateValueAndValidity();
        evento.form.controls['municipality'].addValidators(Validators.required);
        evento.form.controls['municipality'].updateValueAndValidity();
        evento.form.controls['otroDepartamento'].reset();
        evento.form.controls['otroDepartamento'].removeValidators(Validators.required);
        evento.form.controls['otroDepartamento'].updateValueAndValidity();
        evento.form.controls['otroMunicipio'].reset();
        evento.form.controls['otroMunicipio'].removeValidators(Validators.required);
        evento.form.controls['otroMunicipio'].updateValueAndValidity();
      } else {
        evento.form.controls['otroDepartamento'].addValidators(Validators.required);
        evento.form.controls['otroDepartamento'].markAllAsTouched();
        evento.form.controls['otroMunicipio'].addValidators(Validators.required);
        evento.form.controls['otroMunicipio'].markAllAsTouched();
        evento.form.controls['departament'].removeValidators(
          Validators.required
        );
        evento.form.controls['municipality'].removeValidators(
          Validators.required
        );
      }
    }
  }

  capturarFormTipoRevisor(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formTipoRevisor = evento.form;
    if (evento.controlName == 'tipoPersonaRevisor') {
      let tipo = evento.controlValue as FormFieldOption;
      // Revisor persona natural
      if (tipo.Id == 1) {
        this.mostrarRevisorPN = true;
        this.mostrarRevisorPJ = false;
        this.formRevisorPJ?.reset();
      }
      // Revisor persona jurídica
      if (tipo.Id == 2) {
        this.mostrarRevisorPJ = true;
        this.mostrarRevisorPN = false;
        this.formRevisorPN?.reset();
      }
    }
  }

  capturarFormTipoApoderado(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formTipoApoderado = evento.form;
    if (evento.controlName == 'tipoPersonaApoderado') {
      let tipo = evento.controlValue as FormFieldOption;
      // Apoderado persona natural
      if (tipo.Id == 1) {
        this.mostrarApoderadoPN = true;
        this.mostrarApoderadoPJ = false;
        this.formApoderadoPJ?.reset();
      }
      // Apoderado persona jurídica
      if (tipo.Id == 2) {
        this.mostrarApoderadoPJ = true;
        this.mostrarApoderadoPN = false;
        this.formApoderadoPN?.reset();
      }
    }
  }

  capturarFormTipoContador(evento: { controlName?: string; controlValue: unknown; form: FormGroup }) {
    this.formTipoContador = evento.form;
    if (evento.controlName == 'tipoPersonaContador') {
      let tipo = evento.controlValue as FormFieldOption;
      // Contador persona natural
      if (tipo.Id == 1) {
        this.mostrarContadorPN = true;
        this.mostrarContadorPJ = false;
        this.formContadorPJ?.reset();
      }
      // Contador persona jurídica
      if (tipo.Id == 2) {
        this.mostrarContadorPJ = true;
        this.mostrarContadorPN = false;
        this.formContadorPN?.reset();
      }
    }
  }

  habilitarTipoRevisor() {
    this.mostrarTipoRevisor = true;
  }

  habilitarTipoApoderado() {
    this.mostrarTipoApoderado = true;
  }

  habilitarTipoContador() {
    this.mostrarTipoContador = true;
  }
  eliminarRevisor(evento: object) {
    let item = evento as ItemTablaDTO;
    this.liqJudicialService.eliminarRevisor(item.item.id).subscribe((resp: RespuestaEliminarDTO) => {
      if (!resp.Activo) {
        this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_eliminado']);
        this.listarRevisores();
        this.listaSimpleRevisores();
      }
    });
  }

  eliminarApoderado(evento: object) {
    let item = evento as ItemTablaDTO;
    this.liqJudicialService.eliminarApoderado(item.item.id).subscribe((resp: RespuestaEliminarDTO) => {
      if (!resp.Activo) {
        this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado_eliminado']);
        this.listarApoderados();
        this.listaSimpleApoderados();
      }
    });
  }

  eliminarContador(evento: object) {
    let item = evento as ItemTablaDTO;
    this.liqJudicialService.eliminarContador(item.item.id).subscribe((resp: RespuestaEliminarDTO) => {
      if (!resp.Activo) {
        this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador_eliminado']);
        this.listarContadores();
        this.listaSimpleContadores();
      }
    });
  }
  guardarProfesional(esEnviar: boolean, profesional: string) {
    this.esPNC = true;
    let proceso = this.construirJSON(esEnviar);
    this.liqJudicialService.liqJudicialPNC(proceso).subscribe((resp: RespuestaDTO) => {
      if (resp.success) {
        this.idProceso = resp.data.Id;
        if (profesional == 'revisor') {
          this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_agregado']);
          this.listarRevisores();
          this.listaSimpleRevisores();
          this.formTipoRevisor?.reset();
          this.formRevisorPN?.reset();
          this.formRevisorPJ?.reset();
          this.mostrarTipoRevisor = false;
          this.mostrarRevisorPN = false;
          this.mostrarRevisorPJ = false;
          this.formTipoRevisor = undefined;
          this.formRevisorPN = undefined;
          this.formRevisorPJ = undefined;
        }
        if (profesional == 'apoderado') {
          this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado_agregado']);
          this.listarApoderados();
          this.listaSimpleApoderados();
          this.formTipoApoderado?.reset();
          this.formApoderadoPN?.reset();
          this.formApoderadoPJ?.reset();
          this.mostrarTipoApoderado = false;
          this.mostrarApoderadoPN = false;
          this.mostrarApoderadoPJ = false;
          this.formTipoApoderado = undefined;
          this.formApoderadoPN = undefined;
          this.formApoderadoPJ = undefined;
        }
        if (profesional == 'contador') {
          this.alertaModalService.exito(this.roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador_agregado']);
          this.listarContadores();
          this.listaSimpleContadores();
          this.formTipoContador?.reset();
          this.formContadorPN?.reset();
          this.formContadorPJ?.reset();
          this.mostrarTipoContador = false;
          this.mostrarContadorPN = false;
          this.mostrarContadorPJ = false;
          this.formTipoContador = undefined;
          this.formContadorPN = undefined;
          this.formContadorPJ = undefined;

        }
      } else {
        this.alertaModalService.error(resp.message);
      }
    });
  }
  // Función que recorre la lista de revisores y retorna el arreglo con el JSON que el servicio requiere
  procesarArrayRevisores() {
    let arrayRevisores: ProfesionalDTO[] = [];
    // Si existen revisores almacenados previamente y agregan uno nuevo desde el formulario, se adiciona al arreglo
    if (this.formTipoRevisor) {
      if (this.formTipoRevisor.get('tipoPersonaRevisor')?.value == 1) {
        if (this.formRevisorPN?.valid) {
          arrayRevisores.push(this.construirJSONRevisor());
        }
      } else if (this.formTipoRevisor.get('tipoPersonaRevisor')?.value == 2) {
        if (this.formRevisorPJ?.valid) {
          arrayRevisores.push(this.construirJSONRevisor());
        }
      }
    }
    this.datosRevisores.forEach(revisor => {
      arrayRevisores.push({
        id: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Id_Persona
          : revisor.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id_Persona,
        idPersonaNatural: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Id
          : undefined,
        idPersonaJuridica: revisor.persona.Id_Tipo_Persona == 2
          ? revisor.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id
          : undefined,
        idTipoPersona: revisor.persona.Id_Tipo_Persona,
        idTipoIdentificacion: revisor.persona.Id_Tipo_Identificacion,
        identificacion: revisor.persona.Identificacion,
        primerNombre: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Primer_nombre
          : null,
        segundoNombre: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Segundo_nombre
          : null,
        primerApellido: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Primer_apellido
          : null,
        segundoApellido: revisor.persona.Id_Tipo_Persona == 1
          ? revisor.persona.Persona_Natural[0].Segundo_apellido
          : null,
        razonSocial: revisor.persona.Id_Tipo_Persona == 2
          ? revisor.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Razon_Social
          : null,
        pais: revisor.persona.Municipio.Departamento.Pais.Id
          ? { id: revisor.persona.Municipio.Departamento.Pais.Id }
          : undefined,
        departamento: revisor.persona.Municipio.Departamento.Id
          ? { id: revisor.persona.Municipio.Departamento.Id }
          : undefined,
        municipio: revisor.persona.Municipio.Id
          ? { id: revisor.persona.Municipio.Id }
          : undefined,
        otroDepartamento: revisor.persona.Otro_Departamento
          ? revisor.persona.Otro_Departamento
          : null,
        otroMunicipio: revisor.persona.Otro_Municipio
          ? revisor.persona.Otro_Municipio
          : null,
        direccionPersona: [{
          direccionNotificacion: revisor.persona.Direccion_Persona[0].Direccion_Notificacion
        }],
        telefonoPrincipal: revisor.persona.Telefono_Principal,
        correoElectronico: revisor.persona.Correo_electronico
      });
    });
    return arrayRevisores;
  }
  // Función que recorre la lista de apoderados y retorna el arreglo con el JSON que el servicio requiere
  procesarArrayApoderados() {
    let arrayApoderados: ProfesionalDTO[] = [];
    // Si existen apoderados almacenados previamente y agregan uno nuevo desde el formulario, se adiciona al arreglo
    if (this.formTipoApoderado) {
      if (this.formTipoApoderado.get('tipoPersonaApoderado')?.value == 1) {
        if (this.formApoderadoPN?.valid) {
          arrayApoderados.push(this.construirJSONApoderado());
        }
      } else if (this.formTipoApoderado.get('tipoPersonaApoderado')?.value == 2) {
        if (this.formApoderadoPJ?.valid) {
          arrayApoderados.push(this.construirJSONApoderado());
        }
      }
    }
    this.datosApoderados.forEach(apoderado => {
      arrayApoderados.push({
        id: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Id_Persona
          : apoderado.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id_Persona,
        idPersonaNatural: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Id
          : undefined,
        idPersonaJuridica: apoderado.persona.Id_Tipo_Persona == 2
          ? apoderado.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id
          : undefined,
        idTipoPersona: apoderado.persona.Id_Tipo_Persona,
        idTipoIdentificacion: apoderado.persona.Id_Tipo_Identificacion,
        identificacion: apoderado.persona.Identificacion,
        primerNombre: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Primer_nombre
          : null,
        segundoNombre: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Segundo_nombre
          : null,
        primerApellido: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Primer_apellido
          : null,
        segundoApellido: apoderado.persona.Id_Tipo_Persona == 1
          ? apoderado.persona.Persona_Natural[0].Segundo_apellido
          : null,
        razonSocial: apoderado.persona.Id_Tipo_Persona == 2
          ? apoderado.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Razon_Social
          : null,
        pais: apoderado.persona.Municipio.Departamento.Pais.Id
          ? { id: apoderado.persona.Municipio.Departamento.Pais.Id }
          : undefined,
        departamento: apoderado.persona.Municipio.Departamento.Id
          ? { id: apoderado.persona.Municipio.Departamento.Id }
          : undefined,
        municipio: apoderado.persona.Municipio.Id
          ? { id: apoderado.persona.Municipio.Id }
          : undefined,
        otroDepartamento: apoderado.persona.Otro_Departamento
          ? apoderado.persona.Otro_Departamento
          : null,
        otroMunicipio: apoderado.persona.Otro_Municipio
          ? apoderado.persona.Otro_Municipio
          : null,
        direccionPersona: [{
          direccionNotificacion: apoderado.persona.Direccion_Persona[0].Direccion_Notificacion
        }],
        telefonoPrincipal: apoderado.persona.Telefono_Principal,
        correoElectronico: apoderado.persona.Correo_electronico
      });
    });
    return arrayApoderados;
  }
  // Función que recorre la lista de contadores y retorna el arreglo con el JSON que el servicio requiere
  procesarArrayContadores() {
    let arrayContadores: ProfesionalDTO[] = [];
    // Si existen contadores almacenados previamente y agregan uno nuevo desde el formulario, se adiciona al arreglo
    if (this.formTipoContador) {
      if (this.formTipoContador.get('tipoPersonaContador')?.value == 1) {
        if (this.formContadorPN?.valid) {
          arrayContadores.push(this.construirJSONContador());
        }
      } else if (this.formTipoContador.get('tipoPersonaContador')?.value == 2) {
        if (this.formContadorPJ?.valid) {
          arrayContadores.push(this.construirJSONContador());
        }
      }
    }
    this.datosContadores.forEach(contador => {
      arrayContadores.push({
        id: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Id_Persona
          : contador.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id_Persona,
        idPersonaNatural: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Id
          : undefined,
        idPersonaJuridica: contador.persona.Id_Tipo_Persona == 2
          ? contador.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Id
          : undefined,
        idTipoPersona: contador.persona.Id_Tipo_Persona,
        idTipoIdentificacion: contador.persona.Id_Tipo_Identificacion,
        identificacion: contador.persona.Identificacion,
        primerNombre: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Primer_nombre
          : null,
        segundoNombre: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Segundo_nombre
          : null,
        primerApellido: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Primer_apellido
          : null,
        segundoApellido: contador.persona.Id_Tipo_Persona == 1
          ? contador.persona.Persona_Natural[0].Segundo_apellido
          : null,
        razonSocial: contador.persona.Id_Tipo_Persona == 2
          ? contador.persona.Persona_Juridica_Persona_Juridica_Id_PersonaToPersona[0].Razon_Social
          : null,
        pais: contador.persona.Municipio.Departamento.Pais.Id
          ? { id: contador.persona.Municipio.Departamento.Pais.Id }
          : undefined,
        departamento: contador.persona.Municipio.Departamento.Id
          ? { id: contador.persona.Municipio.Departamento.Id }
          : undefined,
        municipio: contador.persona.Municipio.Id
          ? { id: contador.persona.Municipio.Id }
          : undefined,
        otroDepartamento: contador.persona.Otro_Departamento
          ? contador.persona.Otro_Departamento
          : null,
        otroMunicipio: contador.persona.Otro_Municipio
          ? contador.persona.Otro_Municipio
          : null,
        direccionPersona: [{
          direccionNotificacion: contador.persona.Direccion_Persona[0].Direccion_Notificacion
        }],
        telefonoPrincipal: contador.persona.Telefono_Principal,
        correoElectronico: contador.persona.Correo_electronico
      });
    });
    return arrayContadores;
  }
  // Función que construye el JSON de revisores, con los datos de los formularios
  construirJSONRevisor() {
    const idPaisRevisor = this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
      ? this.formRevisorPN?.controls['country']?.value
      : this.formRevisorPJ?.controls['country']?.value;
    const idDepartamentoRevisor = this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
      ? this.formRevisorPN?.controls['departament']?.value
      : this.formRevisorPJ?.controls['departament']?.value;
    const idMunicipioRevisor = this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
      ? this.formRevisorPN?.controls['municipality']?.value
      : this.formRevisorPJ?.controls['municipality']?.value;
    const direccionRevisor = this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
      ? this.formRevisorPN?.controls['direccion']?.value
      : this.formRevisorPJ?.controls['direccion']?.value;
    return {
      idTipoPersona: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value,
      idTipoIdentificacion: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['typeOfDocument']?.value
        : this.formRevisorPJ?.controls['typeOfDocument']?.value,
      identificacion: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['numberOfDocument']?.value
        : this.formRevisorPJ?.controls['numberOfDocument']?.value,
      primerNombre: this.formRevisorPN?.controls['primerNombre']?.value,
      segundoNombre: this.formRevisorPN?.controls['segundoNombre']?.value,
      primerApellido: this.formRevisorPN?.controls['primerApellido']?.value,
      segundoApellido: this.formRevisorPN?.controls['segundoApellido']?.value,
      razonSocial: this.formRevisorPJ?.controls['razonSocial']?.value,
      pais: idPaisRevisor ? { id: idPaisRevisor } : undefined,
      departamento: idDepartamentoRevisor ? { id: idDepartamentoRevisor } : undefined,
      municipio: idMunicipioRevisor ? { id: idMunicipioRevisor } : undefined,
      otroDepartamento: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['otroDepartamento']?.value
        : this.formRevisorPJ?.controls['otroDepartamento']?.value,
      otroMunicipio: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['otroMunicipio']?.value
        : this.formRevisorPJ?.controls['otroMunicipio']?.value,
      direccionPersona: direccionRevisor ? [{ direccionNotificacion: direccionRevisor }] : undefined,
      telefonoPrincipal: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['telefono']?.value
        : this.formRevisorPJ?.controls['telefono']?.value,
      correoElectronico: this.formTipoRevisor?.controls['tipoPersonaRevisor']?.value == 1
        ? this.formRevisorPN?.controls['correo']?.value
        : this.formRevisorPJ?.controls['correo']?.value
    }
  }
  // Función que construye el JSON de apoderados, con los datos de los formularios
  construirJSONApoderado() {
    const idPaisApoderado = this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
      ? this.formApoderadoPN?.controls['country']?.value
      : this.formApoderadoPJ?.controls['country']?.value;
    const idDepartamentoApoderado = this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
      ? this.formApoderadoPN?.controls['departament']?.value
      : this.formApoderadoPJ?.controls['departament']?.value;
    const idMunicipioApoderado = this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
      ? this.formApoderadoPN?.controls['municipality']?.value
      : this.formApoderadoPJ?.controls['municipality']?.value;
    const direccionApoderado = this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
      ? this.formApoderadoPN?.controls['direccion']?.value
      : this.formApoderadoPJ?.controls['direccion']?.value
    return {
      idTipoPersona: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value,
      idTipoIdentificacion: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['typeOfDocument']?.value
        : this.formApoderadoPJ?.controls['typeOfDocument']?.value,
      identificacion: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['numberOfDocument']?.value
        : this.formApoderadoPJ?.controls['numberOfDocument']?.value,
      primerNombre: this.formApoderadoPN?.controls['primerNombre']?.value,
      segundoNombre: this.formApoderadoPN?.controls['segundoNombre']?.value,
      primerApellido: this.formApoderadoPN?.controls['primerApellido']?.value,
      segundoApellido: this.formApoderadoPN?.controls['segundoApellido']?.value,
      razonSocial: this.formApoderadoPJ?.controls['razonSocial']?.value,
      pais: idPaisApoderado ? { id: idPaisApoderado } : undefined,
      departamento: idDepartamentoApoderado ? { id: idDepartamentoApoderado } : undefined,
      municipio: idMunicipioApoderado ? { id: idMunicipioApoderado } : undefined,
      otroDepartamento: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['otroDepartamento']?.value
        : this.formApoderadoPJ?.controls['otroDepartamento']?.value,
      otroMunicipio: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['otroMunicipio']?.value
        : this.formApoderadoPJ?.controls['otroMunicipio']?.value,
      direccionPersona: direccionApoderado ? [{ direccionNotificacion: direccionApoderado }] : undefined,
      telefonoPrincipal: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['telefono']?.value
        : this.formApoderadoPJ?.controls['telefono']?.value,
      correoElectronico: this.formTipoApoderado?.controls['tipoPersonaApoderado']?.value == 1
        ? this.formApoderadoPN?.controls['correo']?.value
        : this.formApoderadoPJ?.controls['correo']?.value
    }
  }
  // Función que construye el JSON de contadores, con los datos de los formularios
  construirJSONContador() {
    const idPaisContador = this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
      ? this.formContadorPN?.controls['country']?.value
      : this.formContadorPJ?.controls['country']?.value;
    const idDepartamentoContador = this.formTipoContador?.controls['tipoPersonaContador'].value == 1
      ? this.formContadorPN?.controls['departament']?.value
      : this.formContadorPJ?.controls['departament']?.value;
    const idMunicipioContador = this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
      ? this.formContadorPN?.controls['municipality']?.value
      : this.formContadorPJ?.controls['municipality']?.value;
    const direccionContador = this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
      ? this.formContadorPN?.controls['direccion']?.value
      : this.formContadorPJ?.controls['direccion']?.value;
    return {
      idTipoPersona: this.formTipoContador?.controls['tipoPersonaContador']?.value,
      idTipoIdentificacion: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['typeOfDocument']?.value
        : this.formContadorPJ?.controls['typeOfDocument']?.value,
      identificacion: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['numberOfDocument']?.value
        : this.formContadorPJ?.controls['numberOfDocument']?.value,
      primerNombre: this.formContadorPN?.controls['primerNombre']?.value,
      segundoNombre: this.formContadorPN?.controls['segundoNombre']?.value,
      primerApellido: this.formContadorPN?.controls['primerApellido']?.value,
      segundoApellido: this.formContadorPN?.controls['segundoApellido']?.value,
      razonSocial: this.formContadorPJ?.controls['razonSocial']?.value,
      pais: idPaisContador ? { id: idPaisContador } : undefined,
      departamento: idDepartamentoContador ? { id: idDepartamentoContador } : undefined,
      municipio: idMunicipioContador ? { id: idMunicipioContador } : undefined,
      otroDepartamento: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['otroDepartamento']?.value
        : this.formContadorPJ?.controls['otroDepartamento']?.value,
      otroMunicipio: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['otroMunicipio']?.value
        : this.formContadorPJ?.controls['otroMunicipio']?.value,
      direccionPersona: direccionContador ? [{ direccionNotificacion: direccionContador }] : undefined,
      telefonoPrincipal: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['telefono']?.value
        : this.formContadorPJ?.controls['telefono']?.value,
      correoElectronico: this.formTipoContador?.controls['tipoPersonaContador']?.value == 1
        ? this.formContadorPN?.controls['correo']?.value
        : this.formContadorPJ?.controls['correo']?.value
    }
  }
  // Función que retorna el objeto completo de ListaValor
  retornarListaValor(lista: string) {
    let objListaValor: ListaValorRequestDto | undefined;
    switch (lista) {
      case 'codigoCIIU':
        return objListaValor = this.listaValorCodigoCIIU.find((item: ListaValorRequestDto) =>
          item.id == this.formIDdeudor.controls['codigoCIIU']?.value);
      case 'baseContable':
        return objListaValor = this.listaValorBaseContable.find((item: ListaValorRequestDto) =>
          item.id == this.formInfoFinancieraMes.controls['baseContable']?.value);
      case 'baseContable1':
        return objListaValor = this.listaValorBaseContable.find((item: ListaValorRequestDto) =>
          item.id == this.formEstadosFinancieros.controls['baseContable1']?.value);
      case 'baseContable2':
        return objListaValor = this.listaValorBaseContable.find((item: ListaValorRequestDto) =>
          item.id == this.formEstadosFinancieros.controls['baseContable2']?.value);
      case 'baseContable3':
        return objListaValor = this.listaValorBaseContable.find((item: ListaValorRequestDto) =>
          item.id == this.formEstadosFinancieros.controls['baseContable3']?.value);
      case 'certificoActividad':
        return objListaValor = this.listaValorCesePagos.find((item: ListaValorRequestDto) =>
          item.id == this.formSupuestos.controls['certificoActividad']?.value);
      case 'macrosector':
        return objListaValor = this.listaValorMacrosector.find((item: ListaValorRequestDto) =>
          item.id == this.formIDdeudor.controls['macrosector']?.value);
      case 'tipoSolicitante':
        return objListaValor = this.listaValorTipoSolicitante.find((item: ListaValorRequestDto) =>
          item.codigo == 'PNC');
    }
    return objListaValor;
  }
}
